import { render, staticRenderFns } from "./BowIconIdromassaggio.vue?vue&type=template&id=12fd3766&"
import script from "./BowIconIdromassaggio.vue?vue&type=script&lang=js&"
export * from "./BowIconIdromassaggio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports